import React from 'react';
import { css } from 'emotion';

const avatarsStyle = css`
  position: absolute;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  img {
    position: absolute;
  }
`;

export const Avatars = ({ avatars }: any) => {
  return (
    <div className={avatarsStyle}>
      {avatars.map((avatar: any, index: number) => (
        <img
          key={index}
          src={avatar.src}
          alt="Avatar"
          style={{ width: '100%', height: '100%', zIndex: avatar.zIndex }}
        />
      ))}
    </div>
  );
};
